import { readonly, ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';


export function useAttendanceMark() {
  const submitting = ref(false);
  const error = ref(null);

  const runRequest = async (url, payload) => {
    submitting.value = true;
    error.value = null;

    try {
      const response = await axiosClient.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
        timeout: 10000
      });
      return { success: true, data: response.data };
    } catch (requestError) {
      error.value = requestError.response?.data?.error
        || requestError.message
        || 'Attendance could not be saved.';
      return {
        success: false,
        error: error.value,
        code: requestError.response?.data?.code,
        status: requestError.response?.status
      };
    } finally {
      submitting.value = false;
    }
  };

  const markRosterAttendance = payload => runRequest(
    API_ENDPOINTS.markRosterAttendance,
    payload
  );

  const addAttendanceCheckout = payload => runRequest(
    API_ENDPOINTS.addAttendanceCheckout,
    payload
  );

  return {
    submitting: readonly(submitting),
    error: readonly(error),
    markRosterAttendance,
    addAttendanceCheckout
  };
}
